// action - customization reducer
export const SET_MENU = '@customization/SET_MENU'
export const MENU_TOGGLE = '@customization/MENU_TOGGLE'
export const MENU_OPEN = '@customization/MENU_OPEN'

export { loadingStart, loadingStop, notificationFail, notificationSuccess, notificationWarning } from './customization'
export { userDetails, updateUserObject } from './setting'
